import { useSelector } from "react-redux";
import { createStyles, Grid, Group, HoverCard, Text} from '@mantine/core';
import intl from "react-intl-universal";
import ShowUsaveHtml from "./ShowUsaveHtml";
import { useEffect, useState } from "react";


const useStyles = createStyles((theme) => ({
  padbottom0: {
    padding: '0px',
  },
}));


export function SignDocumentStatus(props: any) {
   const { classes } = useStyles();
   const [datasignstatus, setdataSignStatus] = useState<any[]>([]);
   const initdocs = useSelector((state: any) => state.user.meetingdocs)

  useEffect(() => {
   const datatosignstatus = initdocs?.filter((obj: { resourceId: any }) => obj.resourceId === props.resourceId) || [];
   if (datatosignstatus[0]){
     setdataSignStatus(datatosignstatus[0].signatures || [])
   }
  }, [props, initdocs]);

  //console.log("initdocs",initdocs)


function isDocumentUnsigned(participant: { documents: any[]; }, targetResourceId: any) {
    // Check if the participant object exists and has a documents array
    if (!participant || !participant.documents || participant.documents.length === 0) {
        return false;
    }

    // Array.prototype.some() returns true as soon as one document satisfies the condition
    return participant.documents.some(document => {
        // Check for BOTH conditions: resourceId match AND isSigned is false
        return (
            document.resourceId === targetResourceId && 
            document.isSigned === true
        );
    });
}

function checkDocumentIsSignedByAll(data: any[], targetResourceId: any) {
    // Array.prototype.some() checks if at least one element satisfies a condition
    return data.some(document => {
        // Check for BOTH conditions: resourceId match AND isSignedByAll is true
        return (
            document.resourceId === targetResourceId && 
            document.isSignedByAll === true
        );
    });
}

const issignbyall = checkDocumentIsSignedByAll(initdocs, props.resourceId);



   //console.log("inidocs:",initdocs);

  /* const rowsout = (filteredArray  || []).map((item:any, index:any) => {

   const isSignt = isDocumentUnsigned(item, props.resourceId);

   let color = "red"
   if (isSignt) {
    color = "green"; 
   }
    
    return (
            <Grid.Col span={12} className={classes.padbottom0} key={item.userId || index}>
                <Group spacing="xs"> 
                    <FileCheck size={20} strokeWidth={1} color={color} />
                    <span>{item.firstName}</span> 
                    <span>{item.lastName || item.lastname}</span> 
                </Group>
            </Grid.Col>
        );
    
   }); */

   //console.log("datasignstatus:",datasignstatus);


   const rowsout = (datasignstatus  || []).map((item:any, index:any) => {

    return (
        <Grid.Col span={12} className={classes.padbottom0} key={item.userId || index}>
            <Group spacing="xs"><Text c="green"><strong>{item.signatoryName}</strong></Text> </Group>
            <Group spacing="xs">{intl.get('SIGDOCSTATUS_ZEIT')}: {item.timeStamp} </Group>
            <Group spacing="xs">{intl.get('SIGDOCSTATUS_GRUND')}: {item.reason} </Group>
            <Group spacing="xs">{intl.get('SIGDOCSTATUS_ORT')}: {item.location} </Group>
            <hr />
        </Grid.Col>
        );
    
   });

   

  return (
    <>
    
    
     <HoverCard width={400} shadow="md" withinPortal zIndex={9999}>
        <HoverCard.Target>
            <ShowUsaveHtml issignbyall={issignbyall} signscount={datasignstatus?.length}/>
        </HoverCard.Target>
        {datasignstatus?.length > 0 &&
            <HoverCard.Dropdown style={{ maxHeight: '450px', overflowY: 'auto', overflowX: 'hidden' }}>
               <Grid>
                    {rowsout}
               </Grid>
            </HoverCard.Dropdown>
            }
    </HoverCard>
     
   
    </>
  );
}